/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);


document.addEventListener('submit', async function(e){

    const form = e.target.closest('.product-card-form');

    if(!form) return;

    e.preventDefault();

    const button = form.querySelector('.add-to-cart');

    if(button){
        button.disabled = true;
        button.classList.add('loading');
        button.innerText = 'Adding...';
    }

    try {

        const formData = new FormData(form);

        const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: {
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        console.log('Added:', data);

        // Refresh cart drawer
        document.dispatchEvent(
            new CustomEvent('dispatch:cart-drawer:refresh')
        );

        // Open cart drawer
        document.dispatchEvent(
            new CustomEvent('dispatch:cart-drawer:open', {
                detail: {
                    opener: button
                }
            })
        );

        if(button){
            button.innerText = 'Added ✓';

            setTimeout(() => {
                button.disabled = false;
                button.classList.remove('loading');
                button.innerText = 'Add to cart';
            }, 1200);
        }

    } catch(error){

        console.error(error);

        if(button){
            button.disabled = false;
            button.classList.remove('loading');
            button.innerText = 'Error';
        }

    }

});

//         document.addEventListener('click', function(e){

//     const swatch = e.target.closest('.swatch-selctr');

//     if(!swatch) return;

//     const datavar = swatch.dataset.varid;

//     const productBlock = swatch.closest('.product-block');

//     if(!productBlock) return;

//     const variantInput = productBlock.querySelector(
//       '.product-card-form input[name="id"]'
//     ); 

//     if(variantInput){
//         variantInput.value = datavar;
//     }

//     const allSwatches = productBlock.querySelectorAll('.swatch-selctr');

//     allSwatches.forEach(item => {
//         item.classList.remove('selected');
//     });

   
//     swatch.classList.add('selected');

// });